export enum StorageKeys {
  ANON_EMAIL = "anon-email",
  ANON_NAME = "anon-name",
  ANON_FIRST_NAME = "anon-first-name",
  ANON_LAST_NAME = "anon-last-name",
  ANON_COMPANY = "anon-company",
}
